function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "white"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M7.71053 15.7352H16.1885C16.5807 15.7352 16.8991 16.0535 16.8991 16.4457C16.8991 16.8379 16.5807 17.1562 16.1885 17.1562H7.71053C7.31832 17.1562 7 16.8379 7 16.4457C7 16.0535 7.31832 15.7352 7.71053 15.7352Z",
  fill: "#0041BE"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 15,
  y: 11,
  width: 10,
  height: 11
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4782 21.8945V10.9981H24.4176V21.8945H15.4782Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1887 10.9978C16.3213 10.9978 16.4521 11.0348 16.5677 11.1068L24.086 15.8446C24.2925 15.9753 24.4185 16.2017 24.4185 16.4462C24.4185 16.6906 24.2925 16.917 24.086 17.0477L16.5677 21.7855C16.3488 21.9229 16.0722 21.9314 15.8458 21.8054C15.6184 21.6804 15.4782 21.4426 15.4782 21.184V11.7084C15.4782 11.4497 15.6184 11.212 15.8458 11.0869C15.9528 11.0272 16.0712 10.9978 16.1887 10.9978Z",
  fill: "#0041BE"
}));

function SvgArrowCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrowCircle.926ed6e0.svg";
export { ForwardRef as ReactComponent };